import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {BackupService} from "../../../services/backup.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-tasktype-detail',
    templateUrl: './tasktype-detail.component.html',
    imports: [
        NgIf,
        ReactiveFormsModule
    ],
    styleUrl: './tasktype-detail.component.scss'
})
export class TasktypeDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private backupService = inject(BackupService);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_tasktype!: string;
    viewMode!: ViewMode;
    tasktype: any;

    ngOnInit(): void {
        this.id_tasktype = this.route.snapshot.paramMap.get('id');
        this.viewMode = this.id_tasktype == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: [null, Validators.required],
        });

        if (this.id_tasktype !== '0') {
            this.getTaskType();
        }
    }

    getTaskType(): void {
        this.dataService.request('Tasktype/get', {
            id_tasktype: this.id_tasktype
        }).subscribe(response => {
            this.tasktype = response.tasktype;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.tasktype.id,
            name: this.tasktype.name,
        });
    }

    save(): void {
        this.dataService.request('Tasktype/save', {
            tasktype: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/tasktype']);
            this.toastrService.success('Der Aufgabentyp wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Tasktype/update', {
            tasktype: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getTaskType();
            this.toastrService.success('Der Aufgabentyp wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/tasktype']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getTaskType();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Aufgabentyp wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Tasktype/delete', {
                    id_tasktype: this.id_tasktype
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Der Aufgabentyp wurde gelöscht');
                });
            }
        });
    }

}
